import React from "react";
import { Button } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserPlus } from "@fortawesome/pro-solid-svg-icons";

import { useTranslation } from "react-i18next";

import type { IProfile, IPartnerUserSlim } from "App/Modules/Models";
import { Permission } from "App/Modules/Models";
import { hasUserPermissionAnywhere } from "App/ReactComponents/Shared";

import { PartnerUsersList } from "./PartnerUsersList";

type PartnerUsersListProps = {
    partnerUsers: IPartnerUserSlim[];
    profile: IProfile;
    addPartnerUser: () => void;
    isLoading: boolean;
};

export const PartnerUsers = (props: PartnerUsersListProps) => {
    const { partnerUsers, profile, addPartnerUser, isLoading } = props;
    const { t } = useTranslation();

    return isLoading ? (
        <React.Fragment>
            <h2 className="title title--h2 partner-details__users-title">
                <Skeleton variant="text" animation="wave" height="1.6em" width="30%" />
            </h2>
            <div className="card card--extra-padding">
                <div className="scrollable-list">
                    <div className="title title--h3 scrollable-list__header">
                        <Skeleton variant="text" animation="wave" height="1.6em" width="25%" />
                    </div>
                    <div className="scrollable-list__buttons">
                        <Button
                            variant="contained"
                            size="small"
                            color="primary"
                            disabled
                            startIcon={<FontAwesomeIcon icon={faUserPlus} className="partner-details__button-icon" />}
                        >
                            {t("Entities.Partner.AddUser")}
                        </Button>
                    </div>
                    <div className="scrollable-list__content scrollable-list__content--dark">
                        <div className="scrollable-list__scroller scrollable-list__scroller--large">
                            <Skeleton variant="rect" animation="wave" height="250px" width="100%" />
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    ) : (
        <React.Fragment>
            <h2 className="title title--h2 partner-details__users-title">{t("Entities.Partner.UsersAndOperators")}</h2>
            <div className="card card--extra-padding">
                <div className="scrollable-list">
                    <h2 className="title title--h3 scrollable-list__header ">
                        {t("Entities.User.Users")}
                        <span className="caption scrollable-list__caption">
                            {`– ${partnerUsers.length} ${t("Entities.Value.Found")}`}
                        </span>
                    </h2>
                    <div className="scrollable-list__buttons">
                        <Button
                            variant="contained"
                            size="small"
                            color="primary"
                            disabled={!hasUserPermissionAnywhere(profile, Permission.PartnerSettings)}
                            startIcon={<FontAwesomeIcon icon={faUserPlus} className="partner-details__button-icon" />}
                            onClick={addPartnerUser}
                        >
                            {t("Entities.Partner.AddUser")}
                        </Button>
                    </div>
                    <div className="scrollable-list__content scrollable-list__content--dark">
                        <div className="scrollable-list__scroller scrollable-list__scroller--large">
                            <PartnerUsersList users={partnerUsers} />
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};
